export const NAV_LINKS = [
  { label: "Servicii", id: "servicii" },
  { label: "Cum funcționează", id: "cum-functioneaza" },
  { label: "Beneficii", id: "beneficii" },
  { label: "Contact", id: "contact" },
];

export const SERVICES = [
  {
    icon: "📊",
    title: "Automatizare Excel & Rapoarte",
    desc: "Eliminăm completarea manuală a fișierelor Excel. Date extrase, procesate și livrate automat, fără erori umane.",
    tags: ["Excel", "CSV", "Rapoarte PDF"],
  },
  {
    icon: "📧",
    title: "Procesare Email & Documente",
    desc: "Emailuri clasificate, răspunsuri automate, date extrase din facturi și contracte direct în sistemele tale.",
    tags: ["Gmail", "Outlook", "OCR"],
  },
  {
    icon: "🔄",
    title: "Sincronizare Date între Sisteme",
    desc: "Conectăm aplicațiile pe care le folosești deja: ERP, CRM, contabilitate — fără introducere manuală.",
    tags: ["API", "Zapier", "n8n"],
  },
  {
    icon: "🤖",
    title: "Asistenți AI Personalizați",
    desc: "Boți antrenați pe datele firmei tale pentru suport intern, răspunsuri clienți sau procesare comenzi.",
    tags: ["ChatGPT", "Claude", "LLM"],
  },
  {
    icon: "📋",
    title: "Fluxuri de Aprobare Automate",
    desc: "Cereri, aprobări și notificări care circulă singure prin echipă — fără follow-up-uri manuale.",
    tags: ["Workflow", "Notificări", "Slack"],
  },
  {
    icon: "📈",
    title: "Dashboard-uri & Monitorizare",
    desc: "Date din toate sursele tale, vizualizate în timp real. Decizii bazate pe date, nu pe instinct.",
    tags: ["BI", "Power BI", "Grafice"],
  },
];

export const STEPS = [
  {
    num: "01",
    title: "Audit gratuit",
    desc: "Analizăm procesele repetitive din firma ta și identificăm unde se pierde cel mai mult timp.",
  },
  {
    num: "02",
    title: "Propunere customizată",
    desc: "Primești o soluție concretă: ce automatizăm, cu ce unelte, în cât timp și la ce cost.",
  },
  {
    num: "03",
    title: "Implementare rapidă",
    desc: "Construim și testăm soluția împreună cu echipa ta. Fără întreruperi în activitate.",
  },
  {
    num: "04",
    title: "Suport continuu",
    desc: "Nu dispărem după livrare. Monitorizăm, ajustăm și extindem soluțiile odată cu firma ta.",
  },
];

export const STATS = [
  { value: "80%", label: "reducere timp sarcini repetitive" },
  { value: "< 2s", label: "timp procesare per document" },
  { value: "0", label: "erori umane în date" },
  { value: "3 săpt.", label: "timp mediu implementare" },
];

export const HERO_STATS = [
  { value: "10+", label: "ani experiență dev" },
  { value: "50+", label: "procese automatizate" },
  { value: "100%", label: "cod personalizat" },
];

export const BENEFITS = [
  "Comunicare directă, fără intermediari",
  "Soluții scalabile, nu workaround-uri",
  "Prețuri corecte pentru firme mici și medii",
  "Disponibil după implementare pentru ajustări",
];

export const BEFORE_AFTER = [
  ["Completare manuală Excel", "Date importate automat"],
  ["2-3 ore/zi procesare", "< 5 minute/zi"],
  ["Erori de copiere frecvente", "Acuratețe 100%"],
  ["Rapoarte lunare cu efort", "Rapoarte live, oricând"],
];
